var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2603 9.534C9.94832 9.534 9.68432 9.426 9.46832 9.21C9.25232 8.994 9.14432 8.73 9.14432 8.418C9.14432 8.106 9.25232 7.842 9.46832 7.626C9.68432 7.41 9.94832 7.302 10.2603 7.302C10.5603 7.302 10.8123 7.41 11.0163 7.626C11.2323 7.842 11.3403 8.106 11.3403 8.418C11.3403 8.73 11.2323 8.994 11.0163 9.21C10.8123 9.426 10.5603 9.534 10.2603 9.534ZM11.0523 11.136V21H9.41432V11.136H11.0523ZM18.65 10.956C19.85 10.956 20.822 11.322 21.566 12.054C22.31 12.774 22.682 13.818 22.682 15.186V21H21.062V15.42C21.062 14.436 20.816 13.686 20.324 13.17C19.832 12.642 19.16 12.378 18.308 12.378C17.444 12.378 16.754 12.648 16.238 13.188C15.734 13.728 15.482 14.514 15.482 15.546V21H13.844V11.136H15.482V12.54C15.806 12.036 16.244 11.646 16.796 11.37C17.36 11.094 17.978 10.956 18.65 10.956Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFooter);
export default __webpack_public_path__ + "static/media/linkedin-footer.ca8ae36f344f69083baefcb4dbe7e97f.svg";
export { ForwardRef as ReactComponent };